<template>
  <div>
    <div class="navigation">
      <div class="navigation_bottom">
        <img class="ai_assistant" ref="ai_assistant" @click="handleScroll(false)"
          src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/AI_Ass/AI_Ass.png" alt="">
        <span ref="scroll_bottom" class="scroll_bottom iconfont" @click="scrollToBottom">&#xe685; 回到底部</span>
      </div>
      <div class="navigation_items" ref="navigation_items">
        <div class="main_input" ref="main_input" @click="handleScroll(true)">
          <div class="upload" @click="handleImageUploadClick($event, '原图')"
            @contextmenu.prevent="handleRightClick($event)">+
            <div class="delete_button iconfont" v-show="imagePath" @click="deleteImage($event, '原图')">&#xe73a;</div>
            <img v-show="imagePath" :src="imagePath" alt="">
          </div>
          <div class="upgap" v-if="['万物迁移', '智能修复'].includes(isCheck)"></div>
          <div class="upload" v-if="['万物迁移', '智能修复'].includes(isCheck)" @click="handleImageUploadClick($event, '遮罩')"
            @contextmenu.prevent>+
            <div class="delete_button iconfont" v-show="maskPath" @click="deleteImage($event, '遮罩')">&#xe73a;</div>
            <img v-show="maskPath" :src="maskPath" alt="">
          </div>
          <div class="upgap" v-if="['替换甲片', '万物迁移'].includes(isCheck)"></div>
          <div class="upload" v-if="['替换甲片', '万物迁移'].includes(isCheck)" @contextmenu.prevent
            @click="handleImageUploadClick($event, '参考图')">+
            <div class="delete_button iconfont" v-show="referencePath" @click="deleteImage($event, '参考图')">&#xe73a;
            </div>
            <img v-show="referencePath" :src="referencePath" alt="">
          </div>
          <textarea name="" id="" placeholder="今天你又有什么好的创意呢?来一起畅玩AI吧!" maxlength="255" v-model="textarea"
            @focus="closeSelectModule"></textarea>
          <button ref="up" class="sent iconfont" @click="startTask">&#xe688;</button>
        </div>
        <div class="module" ref="module">
          <div class="selectmodels iconfont">
            <span class="mudeltitle" @click="selecPattern">
              {{ selectPattern }} &#xeb61;
            </span>
            <!-- 选择模式 -->
            <div class="selectpattern">
              <div class="select_patterns iconfont"
                @click="(isSelectPattern = selectPattern = '自由模式', isActive($event, 'selectPattern'))">
                <span class="patterns_title">&#xe6bc;&nbsp;&nbsp;&nbsp; 自由模式</span>
                <span class="iconfont" v-if="isSelectPattern === '自由模式'"> &#xe982;</span>
              </div>
              <div class="select_patterns iconfont"
                @click="(isSelectPattern = selectPattern = '图像生成', isActive($event, 'selectPattern'), isCheck = '基础模型F.1')">
                <span class="patterns_title">&#xe855;&nbsp;&nbsp;&nbsp; 图像生成</span>
                <span class="iconfont" v-if="isSelectPattern === '图像生成'"> &#xe982;</span>
              </div>
              <div class="select_patterns iconfont"
                @click="(isSelectPattern = selectPattern = '图片处理', isActive($event, 'selectPattern'))">
                <span class="patterns_title">&#xe6b4;&nbsp;&nbsp;&nbsp; 图片处理</span>
                <span class="iconfont" v-if="isSelectPattern === '图片处理'"> &#xe982;</span>
              </div>
              <div class="select_patterns iconfont"
                style="text-decoration: line-through; opacity: 0.5; cursor: default;">
                <span class="patterns_title">&#xe6b1;&nbsp;&nbsp;&nbsp; 模特生成</span>
                <span class="iconfont" v-if="isSelectPattern === '模特生成'"> &#xe982;</span>
              </div>
            </div>
          </div>
          <!-- 图像生成 -->
          <div class="selectpatternresult iconfont" v-if="isSelectPattern === '图像生成'">
            <div class="selectresult iconfont" @click="selectmodulemenu">模型选择 &#xe69e;</div>
            <!-- 生图模型选择 -->
            <div class="selectmodule">
              <div class="select_items"
                @click="(selectModule = isCheck = 'Qwen_Image', isActive($event, 'modelsSelect'))"
                style="text-decoration: line-through; opacity: 0.7; cursor: default;">
                <span class="basemodels iconfont">&#xe6a5;
                  Qwen-Image</span>
                <span class="basiexplain">文生图强，图片排版能力优</span>
                <span class="statusCheck iconfont" v-if="isCheck === 'Qwen_Image'">&#xe982;</span>
              </div>
              <div class="select_items"
                @click="(selectModule = isCheck = 'kontext_Dve', isActive($event, 'modelsSelect'))"
                style="text-decoration: line-through; opacity: 0.7; cursor: default;">
                <span class="basemodels iconfont">&#xe697; Kontext_Dev</span>
                <span class="basiexplain">图形编辑，多状态修改图像</span>
                <span class="statusCheck iconfont" v-if="isCheck === 'kontext_Dve'">&#xe982;</span>
              </div>
              <div class="select_items active"
                @click="(selectModule = isCheck = '基础模型F.1', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe8dc; 基础模型F.1</span>
                <span class="basiexplain">自研模型，风格多样手图必备</span>
                <span class="statusCheck iconfont" v-if="isCheck === '基础模型F.1'">&#xe982;</span>
              </div>
              <div class="select_items"
                @click="(selectModule = isCheck = '基础模型SDXL', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe69c; 基础模型SDXL</span>
                <span class="basiexplain">经典生图，品类较多且应用广</span>
                <span class="statusCheck iconfont" v-if="isCheck === '基础模型SDXL'">&#xe982;</span>
              </div>
              <div class="select_items"
                @click="(selectModule = isCheck = '基础模型SD1.5', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe6a1; 基础模型SD1.5</span>
                <span class="basiexplain">经典生图，甲片款式可用</span>
                <span class="statusCheck iconfont" v-if="isCheck === '基础模型SD1.5'">&#xe982;</span>
              </div>
            </div>
          </div>
          <!-- 图像处理 -->
          <div class="selectpatternresult iconfont" v-show="isSelectPattern === '图片处理'">
            <div class="selectresult iconfont" @click="selectmodulemenu">智能工具箱 &#xe6af;</div>
            <!-- 生图模型选择 -->
            <div class="selectmodule">
              <div class="select_items" @click="(selectModule = isCheck = '智能抠图', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xead0; 智能抠图</span>
                <span class="basiexplain">抠出主体，精准无痕</span>
                <span class="statusCheck iconfont" v-if="isCheck === '智能抠图'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '智能裁切', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe765; 智能裁切</span>
                <span class="basiexplain">一键裁切，化繁为简</span>
                <span class="statusCheck iconfont" v-if="isCheck === '智能裁切'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '无界扩图', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe68d; 无界扩图</span>
                <span class="basiexplain">视觉阔展，AI上未知</span>
                <span class="statusCheck iconfont" v-if="isCheck === '无界扩图'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '超清修复', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe855; 超清修复</span>
                <span class="basiexplain">细节重现，修复低画质</span>
                <span class="statusCheck iconfont" v-if="isCheck === '超清修复'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '万物迁移', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe68e; 万物迁移</span>
                <span class="basiexplain">万千视觉，匹配创意</span>
                <span class="statusCheck iconfont" v-if="isCheck === '万物迁移'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '智能修复', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe779; 智能修复</span>
                <span class="basiexplain">效果自然，无痕修图</span>
                <span class="statusCheck iconfont" v-if="isCheck === '智能修复'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '替换甲片', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe6c1; 替换甲片</span>
                <span class="basiexplain">风格替换，轻松换甲</span>
                <span class="statusCheck iconfont" v-if="isCheck === '替换甲片'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '肤质增强', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xeb7a; 肤质增强</span>
                <span class="basiexplain">皮肤修复，质感增强</span>
                <span class="statusCheck iconfont" v-if="isCheck === '肤质增强'">&#xe982;</span>
              </div>
              <div class="select_items" @click="(selectModule = isCheck = '图像编辑', isActive($event, 'modelsSelect'))">
                <span class="basemodels iconfont">&#xe6b4; 图像编辑</span>
                <span class="basiexplain">图形算法，任意修改</span>
                <span class="statusCheck iconfont" v-if="isCheck === '图像编辑'">&#xe982;</span>
              </div>
            </div>
          </div>
          <!-- 模型选择 -->
          <div class="modelTemplate iconfont" @click="modelTempvisible = true">风格类型 &#xe646;</div>
          <!-- 分辨率选择 -->
          <div class="resolutionList" v-if="['基础模型F.1', '基础模型F.1-p', '基础模型SDXL', '基础模型SD1.5'].includes(isCheck)"
            @click="ResolutionSelect">
            <span class="iconfont">尺寸: {{ absWidth }}px &#xe668;</span>
            <div class="resolution_item" @click="freeResolution($event)">
              <span class="res_items" v-for="item in resolutionList" :key="item">{{ item }}</span>
            </div>
          </div>
          <!-- 图像裁切分辨率 -->
          <div class="resolution" v-if="isCheck === '智能裁切'" @click="handleResolutionSelect">
            <span class="iconfont">{{ resolutionMatch }}: {{ resolutionValue }} px &#xe668;</span>
            <div class="resolution_item" @click="handleWidthHeightMatch">
              <span class="res_items">根据宽|高匹配</span>
              <span class="res_items">512px</span>
              <span class="res_items">640px</span>
              <span class="res_items">768px</span>
              <span class="res_items">960px</span>
              <span class="res_items">1024px</span>
              <span class="res_items">1152px</span>
              <span class="res_items">1261px</span>
              <span class="res_items">1280px</span>
              <span class="res_items">1344px</span>
              <span class="res_items">1536px</span>
              <span class="res_items">1600px</span>
            </div>
          </div>
          <div class="currentSelect iconfont">{{ isCheck }} &#xe691;</div>
          <button ref="down" class="sent iconfont" @click="startTask">&#xe688;</button>
        </div>
      </div>
      <!-- @算法模型选择 -->
      <CallApplication @handleMath="handleMath" :visibleCallBack="visibleCallBack" :isLocked="isLocked"
        @update:visibleCallBack="visibleCallBack = $event">
      </CallApplication>
    </div>
    <el-button plain @click="open1">
      可自动关闭
    </el-button>
    <!-- 右键菜单 -->
    <RightMenu :mouseMenuVisible="mouseMenuVisible" :menuPosition="menuPosition" :rightMenuType="rightMenuType"
      @update:mouseMenuVisible="mouseMenuVisible = $event" @clickfunction="clickfunction"></RightMenu>
    <CanvasPad :imagePath="imagePath" @maskPath="getMaskPath" :visibleCanvas="visibleCanvas"
      @update:visibleCanvas="visibleCanvas = $event">
    </CanvasPad>
    <modelTemplate :favoriteParams="favoriteParams" :isCheck="isCheck" :modelTempvisible="modelTempvisible"
      @selectCheck="selectCheck" @update:modelTempvisible="modelTempvisible = $event">
    </modelTemplate>
  </div>
</template>

<script>
import { fluxImageGen } from '@/utils/AssistantRuquest/fluxImageGen'
import { fluxNormalTemp } from '@/utils/AssistantRuquest/fluxnormaltemp'
import { commonsd1_5 } from '@/utils/AssistantRuquest/commonsd1.5'
import { commonsdxl } from '@/utils/AssistantRuquest/commonsdxl'
import { mattingPro } from '@/utils/AssistantRuquest/mattingpro'
import { boardpicture } from '@/utils/AssistantRuquest/boardpicture'
import { realistichd } from '@/utils/AssistantRuquest/realistichd'
import { cutpicture } from '@/utils/AssistantRuquest/cutpicture'
import { handsrecover } from '@/utils/AssistantRuquest/handsrecover'
import { changefingernail } from '@/utils/AssistantRuquest/changefingernail'
import { wanmove } from '@/utils/AssistantRuquest/wanmove'
import { removecontainer } from '@/utils/AssistantRuquest/removecontainer'
import { gpt4_0 } from '@/utils/AssistantRuquest/gpt4-0'
import { cudaIndexNum } from '@/utils/comfyUiRequest'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import setLocalStorage from '@/utils/setLocalStorage'
import { notification } from '@/utils/notification'
import getImageDimensions from '@/utils/getImageDimensions'
// 收藏图片
import { Pandora } from '@/enums/common/modules'
import { getTaskStart } from '@/api/user'
import { tableRowShow } from '@/utils/mysqTools'
export default {
  name: 'NaviGation',
  data() {
    return {
      // 用户信息
      userInfo: null,
      scrollStatus: false,
      textarea: '',
      processing: false,
      imagePath: '',
      maskPath: '',
      referencePath: '',
      loading: true,
      isSelectModule: true,
      isSelectPatternClick: true,
      selectModule: null,
      isCheck: '基础模型F.1',
      selectPattern: '自由模式',
      isSelectPattern: '自由模式',
      isImageGen: false,
      visibleCallBack: false,
      signalStart: null,
      resolutionList: [
        '512px',
        '640px',
        '768px',
        '896px',
        '960px',
        '1024px',
        '1152px',
        '1261px',
        '1280px',
        '1344px',
        '1536px',
        '1600px'
      ],
      // 常规出图参数
      absWidth: 1024,
      steps: 20,
      guidance: 3.5,
      weight: 0.85,
      cfg: 1.0,
      // 状态锁
      isLocked: false,
      // 智能裁切
      resolutionSelect: false,
      resolutionMatch: '高度',
      resolutionValue: 1600,
      imageWidth: null,
      imageHeight: null,
      // 右键菜单
      mouseMenuVisible: false,
      rightMenuType: '',
      // 添加鼠标坐标
      menuPosition: {
        x: 0,
        y: 0
      },
      // CanvasPad
      visibleCanvas: false,
      // 初始化数据库名称
      tableName: null,
      // 模型库
      modelTempvisible: false,
      // 初始化参数
      fluxTempParam: {
        loraname: 'Flux_MJ/DaviMeijia.safetensors',
        default_tips: 'meijia',
        chinese: '一个女人手上装饰着令人惊叹的指甲艺术设计的特写。每个指甲都独特地涂上了复杂的图案,有些以精致的花朵为特色,而另一些则以金属色调的几何形状为特色。',
        galleryName: 'common_hands'
      },
      sdxlTempParam: {
        loraname: 'SDXL/MoreJoy_Finger_XL_V1.5.safetensors',
        default_tips: 'meijia',
        chinese: '简约背景,逼真效果,指甲,写实风格,橙色背景,指甲油,单个,渐变背景',
        galleryName: 'dazahuisdxl'
      },
      sd15TempParam: {
        loraname: 'SD1.5/视觉应用集 - 真人美甲_v2.1.safetensors',
        default_tips: '',
        chinese: '大理石纹理,萨巴,色彩斑斓,融合,最佳品质,官方艺术,8K 壁纸,细节丰富,插画,细致的',
        galleryName: ''
      },
      favoriteParams: null
    }
  },
  props: {
    scrollTop: {
      type: Boolean,
      default: false
    },
    reEdit: {
      type: Boolean,
      default: false
    },
    input: {
      type: String,
      default: ''
    },
    reTaskParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    container: {
      type: Array,
      default: () => {
        return []
      }
    },
    referenceImage: {
      type: String,
      default: ''
    },
    editImage: {
      type: String,
      default: ''
    },
    uniqueId: {
      type: String,
      default: ''
    }
  },
  watch: {
    scrollTop: function (val) {
      this.handleScroll(val)
    },
    reEdit: async function (val) {
      const param = {
        userId: this.userInfo.userId,
        id: this.uniqueId
      }
      const res = await tableRowShow(param)
      if (res) {
        this.isCheck = res[0][3]
        this.textarea = res[0][4]
        this.imagePath = res[0][9]
        this.maskPath = res[0][10]
        this.referencePath = res[0][11]
        this.steps = res[0][12]
        this.guidance = res[0][13]
        this.weight = res[0][14]
        this.cfg = res[0][15]
        this.absWidth = res[0][16]
        const data = res[0]
        if (this.isCheck === '基础模型SDXL') {
          this.sdxlTempParam.loraname = data[20]
          this.sdxlTempParam.galleryName = data[21]
        }
        if (this.isCheck === '基础模型F.1-p' || this.isCheck === '基础模型F.1') {
          this.fluxTempParam.loraname = data[20]
          this.fluxTempParam.galleryName = data[21]
        }
        if (this.isCheck === '基础模型SD1.5') {
          this.sd15TempParam.loraname = data[20]
          this.sd15TempParam.galleryName = data[21]
        }
        this.open1('success', 'green', '已重新嵌入模式和所有数据!')
      }
    },
    reTaskParams: function (val) {
      // console.log(val)
      this.reGenerate(val)
    },
    referenceImage: function (val) {
      this.referencePath = val
      setLocalStorage.setItem('NaviGation_referencePath', val)
      this.open1('success', 'green', '已用图像嵌入参考!')
    },
    editImage: function (val) {
      this.imagePath = val
      setLocalStorage.setItem('NaviGation', val)
      this.open1('success', 'green', '已用图像嵌入修改!')
    },
    isCheck: function (val) {
      if (val === 'Qwen-Image' || val === 'Kontext_Dev') {
        this.open1('warning', 'rgb(230,125,60)', '当前模式暂未开放,敬请期待!')
      }
    }
  },
  async created() {
    this.imagePath = setLocalStorage.getItem('NaviGation') || ''
    this.maskPath = setLocalStorage.getItem('NaviGation_maskPath') || ''
    this.referencePath = setLocalStorage.getItem('NaviGation_referencePath') || ''
    // 先获取用户信息
    this.userInfo = this.$store.state.morejoy_assistant.userInfo
  },
  mounted() {
    this.$nextTick(() => {
      this.handleScroll(false)
    })
    // 添加键盘监听事件
    window.addEventListener('keydown', this.handleKeystart)
    window.addEventListener('keydown', this.handleKeyclose)
  },
  methods: {
    // 从模型库直接选择模型和模式
    selectCheck(data) {
      this.isCheck = data.modelType
      if (this.isCheck === '基础模型SDXL') {
        this.sdxlTempParam.loraname = data.loraname
        this.sdxlTempParam.default_tips = data.default_tips
        this.sdxlTempParam.chinese = data.chinese
        this.sdxlTempParam.galleryName = data.galleryname
      }
      if (this.isCheck === '基础模型F.1-p' || this.isCheck === '基础模型F.1') {
        this.fluxTempParam.loraname = data.loraname
        this.fluxTempParam.default_tips = data.default_tips
        this.fluxTempParam.chinese = data.chinese
        this.fluxTempParam.galleryName = data.galleryname
      }
      if (this.isCheck === '基础模型SD1.5') {
        this.sd15TempParam.loraname = data.loraname
        this.sd15TempParam.default_tips = data.default_tips
        this.sd15TempParam.chinese = data.chinese
        this.sd15TempParam.galleryName = data.galleryname
      }
      this.textarea = data.default_tips + data.chinese
      this.absWidth = data.width
      this.steps = data.steps
      this.guidance = data.guidance
      this.weight = data.weight
      this.cfg = data.cfg
    },
    // 点击事件
    async clickfunction(data) {
      if (data === '嵌入画板') {
        this.visibleCanvas = true
      }
    },
    // 右键菜单
    handleRightClick(event) {
      this.rightMenuType = 'dock'
      const nav = document.querySelector('.upload')
      const y_xios = event.clientY - nav.clientHeight * 3.6
      this.menuPosition = {
        x: event.clientX,
        y: y_xios
      }
      this.mouseMenuVisible = !this.mouseMenuVisible
    },
    // 分辨率宽高匹配
    async handleWidthHeightMatch(event) {
      if (!this.imagePath) {
        this.open1('warning', 'rgb(230,125,60)', '请先选择一张图片!')
        return
      }
      const imageSize = await getImageDimensions(this.imagePath)
      const { width, height } = imageSize
      const items = event.target.closest('.res_items')
      if (items) {
        if (items.textContent !== '根据宽|高匹配') {
          const resolution = items.textContent.split('px')[0]
          this.resolutionValue = resolution
          this.resolutionMatchFun(this.resolutionMatch, width, height)
        } else {
          if (this.resolutionMatch === '高度') {
            this.resolutionMatch = '宽度'
          } else {
            this.resolutionMatch = '高度'
          }
        }
      }
    },
    // 分辨率匹配函数
    resolutionMatchFun(pattern, width, height) {
      if (pattern === '宽度') {
        this.imageWidth = this.resolutionValue
        const scale = this.imageWidth / width
        this.imageHeight = Math.round(height * scale)
        Number(this.imageWidth)
        Number(this.imageHeight)
        this.open1('warning', 'rgb(230,125,60)', `即将匹配的宽为：${this.imageWidth}  &&高为：${this.imageHeight}!`)
      } else {
        this.imageHeight = this.resolutionValue
        const scale = this.imageHeight / height
        this.imageWidth = Math.round(width * scale)
        Number(this.imageWidth)
        Number(this.imageHeight)
        this.open1('warning', 'rgb(230,125,60)', `即将匹配的宽为：${this.imageWidth}  &&高为：${this.imageHeight}!`)
      }
    },
    // 尺寸分辨率选择
    ResolutionSelect() {
      this.resolutionSelect = !this.resolutionSelect
      const resolution_item = document.querySelector('.resolution_item')
      if (this.resolutionSelect) {
        resolution_item.style.height = '1240%'
        resolution_item.style.padding = '6%'
      } else {
        resolution_item.style.height = '0%'
        resolution_item.style.padding = '0%'
      }
    },
    // 自由分辨率
    freeResolution(event) {
      const items = event.target.closest('.res_items')
      if (items) {
        this.absWidth = Number(items.textContent.split('px')[0])
      }
    },
    // 裁切分辨率选择
    handleResolutionSelect() {
      this.resolutionSelect = !this.resolutionSelect
      const resolution_item = document.querySelector('.resolution_item')
      if (this.resolutionSelect) {
        resolution_item.style.height = '1240%'
        resolution_item.style.padding = '6%'
      } else {
        resolution_item.style.height = '0%'
        resolution_item.style.padding = '0%'
      }
    },
    // 键盘监听
    handleKeystart(event) {
      if (event.shiftKey && event.key === '@') {
        this.visibleCallBack = !this.visibleCallBack
        this.textarea = ''
      }
      if (event.shiftKey && event.key === 'Process') {
        this.visibleCallBack = !this.visibleCallBack
        this.textarea = ''
      }
      if (event.ctrlKey && event.key === 'Enter') {
        try { this.startTask(event) } catch (e) { console.log(e) }
      }
      if (event.shiftKey && event.key === 'W') {
        this.modelTempvisible = !this.modelTempvisible
      }
    },
    // @算法
    handleMath(math) {
      this.isCheck = math
    },
    // 监听关闭事件
    handleKeyclose(event) {
      if (event.key === 'Escape') {
        this.closeSelectModule()
        if (this.resolutionSelect) {
          this.resolutionSelect = !this.resolutionSelect
          const resolution_item = document.querySelector('.resolution_item')
          resolution_item.style.height = '0%'
          resolution_item.style.padding = '0%'
        }
      }
      if (event.shiftKey && event.key === 'E') {
        this.closeSelectModule()
        if (this.resolutionSelect) {
          this.resolutionSelect = !this.resolutionSelect
          const resolution_item = document.querySelector('.resolution_item')
          resolution_item.style.height = '0%'
          resolution_item.style.padding = '0%'
        }
      }
    },
    // 导航栏状态
    handleScroll(val) {
      if (val) {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '69.8%'
          this.$refs.navigation_items.style.height = '70%'
        }
        if (this.$refs.module) this.$refs.module.style.display = 'flex'
        if (this.$refs.up) this.$refs.up.style.display = 'none'
        if (this.$refs.down) this.$refs.down.style.display = 'block'
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 1
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 1
        this.scrollStatus = true
      } else {
        if (this.$refs.navigation_items) this.$refs.navigation_items.style.width = '60%'
        if (this.$refs.module) this.$refs.module.style.display = 'none'
        if (this.$refs.up) this.$refs.up.style.display = 'block'
        if (this.$refs.down) this.$refs.down.style.display = 'none'
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 0
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 0
        this.scrollStatus = false
      }
    },
    // 回滚到底部
    scrollToBottom() {
      if (this.scrollStatus) { this.$emit('scrollToBottom') }
    },
    // 开始任务
    async startTask(event) {
      event.stopPropagation()
      // 未上传图片直接返回
      if (!['基础模型F.1', '基础模型F.1-p', '基础模型SDXL', '基础模型SD1.5'].includes(this.isCheck)) {
        if (this.imagePath === '') {
          this.open1('warning', 'rgb(230,125,60)', '请先选择或上传一张图片作为修改!')
          return
        }
      }
      // 暂未开发的功能
      if (this.isCheck === 'Qwen-Image' || this.isCheck === 'Kontext_Dev') {
        this.open1('warning', 'rgb(230,125,60)', '当前模式暂未开放,敬请期待!')
        return
      }
      this.closeSelectModule()
      this.isLocked = true
      this.$emit('progressUpdate', 0)
      if (this.isCheck === '基础模型SDXL' || this.isCheck === '基础模型F.1-p') {
        this.textarea = 'OS: 为保证出图效果,当前模式由AI帮你描述内容'
      }
      if (this.textarea.trim() === '') {
        this.open1('warning', 'rgb(230,125,60)', '请输入内容后再次点击生成按钮!')
        return
      }
      if (this.processing) {
        this.open1('warning', 'rgb(230,125,60)', '任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      const Id = String(Date.now())
      try {
        // 先创建任务队列
        const obj = {
          id: Id,
          userName: this.userInfo.userName,
          userId: this.userInfo.userId,
          modeType: this.isCheck,
          input: this.textarea,
          img1: '',
          img2: '',
          img3: '',
          img4: '',
          uploadImage: this.imagePath,
          uploadMask: this.maskPath,
          referenceImage: this.referencePath,
          steps: this.steps,
          guidance: this.guidance,
          weight: this.weight,
          cfg: this.cfg,
          realResolutionWidth: this.absWidth,
          realResolutionHeight: this.absWidth,
          resolutionMatchWidth: null,
          resolutionMatchHeight: null,
          loraName: null,
          galleryName: null,
          currentTime: null,
          taskLogId: null
        }
        await this.$store.dispatch('morejoy_assistant/insertAndRefresh', obj)
        // 判断列表
        let res = null
        // 添加到任务队列
        this.processing = true
        this.$emit('flush')
        this.open1('success', 'green', '已提交任务,请耐心等待结果生成!')
        this.$nextTick(() => {
          this.$emit('scrollToBottom')
        })
        this.textarea = ''
        const genParam = {
          absWidth: this.absWidth,
          steps: this.steps,
          guidance: this.guidance,
          weight: this.weight,
          cfg: this.cfg
        }
        console.log(obj)
        // 模式判断
        if (this.isCheck === '基础模型F.1') {
          res = await fluxNormalTemp(this.fluxTempParam.loraname, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
          })
          obj.loraName = this.fluxTempParam.loraname
          obj.galleryName = this.fluxTempParam.galleryName
        }
        if (this.isCheck === '基础模型F.1-p') {
          res = await fluxImageGen(this.fluxTempParam.galleryName, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
            obj.loraName = this.fluxTempParam.loraname
            obj.galleryName = this.fluxTempParam.galleryName
          })
        }
        if (this.isCheck === '基础模型SD1.5') {
          res = await commonsd1_5(this.sd15TempParam.loraname, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
            obj.loraName = this.sd15TempParam.loraname
          })
        }
        if (this.isCheck === '基础模型SDXL') {
          res = await commonsdxl(this.sdxlTempParam.galleryName, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
            obj.loraName = this.sdxlTempParam.loraname
            obj.galleryName = this.sdxlTempParam.galleryName
          })
        }
        if (this.isCheck === '智能抠图') {
          res = await mattingPro(this.imagePath, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '智能裁切') {
          res = await cutpicture(this.imagePath, this.imageWidth, this.imageHeight, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '无界扩图') {
          res = await boardpicture(this.imagePath, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '超清修复') {
          res = await realistichd(this.imagePath, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '万物迁移') {
          res = await wanmove(this.imagePath, this.maskPath, this.referencePath, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '智能修复') {
          res = await removecontainer(this.imagePath, this.maskPath, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '替换甲片') {
          res = await changefingernail(this.imagePath, this.referencePath, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '肤质增强') {
          res = await handsrecover(this.imagePath, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (this.isCheck === '图像编辑') {
          res = await gpt4_0(this.imagePath, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        // 获取任务ID
        await getTaskStart({
          type: Pandora,
          prompt: obj.input,
          input_images: [this.imagePath, this.maskPath, this.referencePath].filter(Boolean)
        }).then(rep => {
          obj.taskLogId = rep.data.task.id
        })
        obj.img1 = res.images[0]
        obj.img2 = res.images[1]
        obj.img3 = res.images[2]
        obj.img4 = res.images[3]
        const imageSize = await getImageDimensions(res.images[0])
        const { width, height } = imageSize
        obj.realResolutionWidth = width
        obj.realResolutionHeight = height
        obj.uploadImage = this.imagePath
        obj.uploadMask = this.maskPath
        obj.referenceImage = this.referencePath
        obj.resolutionMatchWidth = this.imageWidth
        obj.resolutionMatchHeight = this.imageHeight
        const now = new Date()
        obj.currentTime = now.toLocaleDateString('zh-CN')
        // 刷新表
        await this.$store.dispatch('morejoy_assistant/modifyAndRefresh', obj)
        this.processing = res.status
        this.isLocked = false
      } catch (error) {
        this.processing = false // 强制弹出
        this.isLocked = false // 解锁
        const index = cudaIndexNum()
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        this.$emit('flush')
        this.open1('error', 'rgb(245,108,108)', '未知的错误导致请求失败,请稍后再试!')
      }
    },
    // 再次生成
    async reGenerate(val) {
      this.isLocked = true
      const obj = { ...val }
      if (this.processing) {
        this.open1('warning', 'rgb(230,125,60)', '任务已在进行中，请勿重复提交以免造成错误!')
      }
      try {
        // 修改当前任务状态和数据
        await this.$store.dispatch('morejoy_assistant/modifyAndRefresh', obj)
        // 先创建任务队列
        let res = null
        this.processing = true
        this.open1('success', 'green', '已提交任务,请耐心等待结果生成!')
        // 给定参数
        const genParam = {
          absWidth: obj.realResolutionWidth,
          steps: obj.steps,
          guidance: obj.guidance,
          weight: obj.weight,
          cfg: obj.cfg
        }
        // 模式判断
        if (obj.modeType === '基础模型F.1') {
          res = await fluxNormalTemp(obj.loraName, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '基础模型F.1-p') {
          res = await fluxImageGen(obj.galleryName, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '基础模型SD1.5') {
          res = await commonsd1_5(obj.loraName, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '基础模型SDXL') {
          res = await commonsdxl(obj.galleryName, obj.input, genParam, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '智能抠图') {
          res = await mattingPro(obj.uploadImage, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '智能裁切') {
          const width = Number(obj.realResolutionWidth)
          const height = Number(obj.realResolutionHeight)
          res = await cutpicture(obj.uploadImage, width, height, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '无界扩图') {
          res = await boardpicture(obj.uploadImage, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '超清修复') {
          res = await realistichd(obj.uploadImage, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '万物迁移') {
          res = await wanmove(obj.uploadImage, obj.uploadMask, obj.referenceImage, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '智能修复') {
          res = await removecontainer(obj.uploadImage, obj.uploadMask, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '替换甲片') {
          res = await changefingernail(obj.uploadImage, obj.referenceImage, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        if (obj.modeType === '图像编辑') {
          res = await gpt4_0(obj.uploadImage, obj.input, (progress) => {
            this.$emit('progressUpdate', progress)
          })
        }
        obj.img1 = res.images[0] || ''
        obj.img2 = res.images[1] || ''
        obj.img3 = res.images[2] || ''
        obj.img4 = res.images[3] || ''
        const imageSize = await getImageDimensions(res.images[0])
        const { width, height } = imageSize
        obj.realResolutionWidth = width
        obj.realResolutionHeight = height
        const now = new Date()
        obj.currentTime = now.toLocaleDateString('zh-CN')
        // 刷新表
        await this.$store.dispatch('morejoy_assistant/modifyAndRefresh', obj)
        this.processing = res.status
        this.isLocked = false
      } catch (error) {
        this.processing = false // 强制弹出
        this.isLocked = false // 解锁
        const index = cudaIndexNum()
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        this.open1('error', 'rgb(245,108,108)', '未知的错误导致请求失败,请稍后再试!')
      }
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/'
      const fileName = file.name
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    // 点击上传按钮
    handleImageUploadClick(event, pattren) {
      event.stopPropagation()
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processImage(file, pattren)
        }
      }
      input.click()
    },
    //  图片处理函数
    async processImage(file, pattren) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)
      if (this.isCheck !== '智能裁切' && this.isCheck !== '智能抠图') {
        // 获取图片尺寸并加以限制
        const imageSize = await getImageDimensions(imageUrl)
        if (imageSize.width > 1600 || imageSize.height > 1600) {
          this.open1('error', 'rgb(245,108,108)', '图片尺寸过大,请重新上传!建议分辨率为1600*1600以内')
          return
        }
      }
      if (pattren === '原图') {
        if (imageUrl) {
          this.imagePath = imageUrl
          setLocalStorage.setItem('NaviGation', imageUrl)
          this.open1('success', 'green', '图片加载成功,可以准备开始任务!')
        }
      }
      if (pattren === '参考图') {
        if (imageUrl) {
          this.referencePath = imageUrl
          setLocalStorage.setItem('NaviGation_referencePath', imageUrl)
          this.open1('success', 'green', '图片加载成功,可以准备开始任务!')
        }
      }
      if (pattren === '遮罩') {
        if (imageUrl) {
          this.maskPath = imageUrl
          setLocalStorage.setItem('NaviGation_maskPath', imageUrl)
          this.open1('success', 'green', '图片加载成功,可以准备开始任务!')
        }
      }
      // 同时显示本地预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(file)
      this.loading = false
    },
    // 从画板获取绘制的遮罩图片
    getMaskPath(data) {
      this.maskPath = data
      setLocalStorage.setItem('NaviGation_maskPath', data)
    },
    // 删除图片
    deleteImage(event, pattern) {
      event.stopPropagation()
      if (pattern === '原图') {
        if (this.imagePath) {
          this.imagePath = '' // 直接修改响应式数据
          localStorage.removeItem('NaviGation')
          this.open1('success', 'green', '修改图已删除,请重新上传图片!')
        }
      }
      if (pattern === '参考图') {
        if (this.referencePath) {
          this.referencePath = '' // 直接修改响应式数据
          localStorage.removeItem('NaviGation_referencePath')
          this.open1('success', 'green', '参考图已删除,请重新上传图片!')
        }
      }
      if (pattern === '遮罩') {
        if (this.maskPath) {
          this.maskPath = '' // 直接修改响应式数据
          localStorage.removeItem('NaviGation_maskPath')
          this.open1('success', 'green', '遮罩图已删除,请重新上传图片!')
        }
      }
    },
    // 模式选择菜单
    selecPattern() {
      if (!this.isLocked) {
        this.isSelectPatternClick = !this.isSelectPatternClick
        const selectmodule = document.querySelector('.selectpattern')
        if (this.isSelectPatternClick === false) {
          selectmodule.style.height = '471%'
          selectmodule.style.padding = '6%'
        }
        if (this.isSelectPatternClick === true) {
          selectmodule.style.height = '0%'
          selectmodule.style.padding = '0%'
        }
      }
    },

    // 模型选择菜单
    selectmodulemenu() {
      if (!this.isLocked) {
        this.isSelectModule = !this.isSelectModule
        const selectmodule = document.querySelector('.selectmodule')
        if (this.isSelectModule === false) {
          selectmodule.style.height = '670%'
          selectmodule.style.padding = '9%'
        }
        if (this.isSelectModule === true) {
          selectmodule.style.height = '0%'
          selectmodule.style.padding = '0%'
        }
      }
    },
    // 关闭模式选择
    closeSelectModule() {
      try { // 关闭模式选择
        this.isSelectPatternClick = false
        const isSelectPatternClick = document.querySelector('.selectpattern')
        isSelectPatternClick.style.height = '0%'
        isSelectPatternClick.style.padding = '0%'
        this.isSelectPatternClick = true
        // 关闭模型选择
        this.isSelectModule = false
        const selectmodule = document.querySelector('.selectmodule')
        selectmodule.style.height = '0%'
        selectmodule.style.padding = '0%'
        this.isSelectModule = true
      } catch (error) {
      }
    },
    // 选中状态
    isActive(event, pattern) {
      let type = null
      if (pattern === 'modelsSelect') {
        type = '.select_items'
      }
      if (pattern === 'selectPattern') {
        type = '.select_patterns'
      }
      const items = event.currentTarget
      const select_items = document.querySelectorAll(`${type}`)
      select_items.forEach(item => {
        item.classList.remove('active')
        items.classList.add('active')
      })
    },
    // 消息通知栏
    open1(type = 'warning', color, notion) {
      notification(type)
      const h = this.$createElement
      this.$notify({
        title: '系统通知',
        type: type,
        message: h('i', { style: `color: ${color}` }, notion)
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeystart)
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.active {
  background: @basicselect;
}

.navigation {
  position: absolute;
  width: calc(100vw - 360px);
  bottom: 15px;
  z-index: 8;
  transition: all 0.5s;

  .navigation_bottom {
    position: relative;
    width: 1536px;
    height: 50px;
    font-size: 23px;
    margin: 0 auto;
    justify-content: space-between;
    margin-bottom: 10px;

    .ai_assistant {
      position: absolute;
      bottom: -10px;
      width: 120px;
      height: 120px;
      opacity: 0;
      transition: all 0.5s;
    }

    .scroll_bottom {
      position: absolute;
      right: 0px;
      font-size: 20px;
      color: @font_white;
      background-color: @morejoy;
      padding: 10px 15px;
      cursor: pointer;
      border-radius: @border_radius_3;
      transition: all 0.5s;
      opacity: 0;
    }
  }

  .navigation_items {
    width: 1336px;
    height: 140px;
    display: flex;
    flex-direction: column;
    background: rgba(235, 235, 235, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid @font_white;
    border-radius: @border_radius;
    transition: all 0.3s;
    margin: 0 auto;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);

    .main_input {
      width: 100%;
      height: 140px;
      display: flex;
      align-items: center;
      padding: 20px 20px;

      .upgap {
        width: 10px;
        height: auto;
      }

      .upload {
        position: relative;
        width: 70px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        font-size: 35px;
        color: @font_white;
        border-radius: @border_radius_2;
        cursor: pointer;
        overflow: hidden;
        background-color: @font_gray;
        opacity: 0.7;
        transition: all 0.3s;
        z-index: 2;

        &:hover {
          opacity: 1;
          font-size: 38px;
        }

        .delete_button {
          color: @morejoy;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          position: absolute;
          top: -30px;
          right: 5px;
          font-size: 20px;
          z-index: 3;
        }

        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 100%;
          height: auto;
        }
      }

      textarea {
        width: calc(100% - 230px);
        font-family: '微软雅黑';
        font-size: 23px;
        padding: 20px;
        border: none;
        background: none;
        resize: none;
        outline: none;
      }

      .sent {
        position: absolute;
        right: 15px;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 35px;
        color: @font_white;
        border: none;
        border-radius: 30px;
        background-color: @font_gray;
        cursor: pointer;
        opacity: 0.7;
        transition: all 0.3s;

        &:hover {
          opacity: 1;
          font-size: 38px;
        }
      }
    }

    .module {
      width: 100%;
      height: 70px;
      display: none;
      gap: 10px;
      padding: 0 20px;

      .selectmodels {
        position: relative;
        width: 170px;
        height: 50px;
        transition: all 0.5s;

        .mudeltitle {
          display: block;
          text-align: center;
          line-height: 50px;
          color: @font_white;
          font-size: 20px;
          background: @morejoy;
          border-radius: @border_radius_2;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            font-size: 22px;
            transition: all 0.5s;
          }
        }

        .selectpattern {
          position: absolute;
          bottom: 60px;
          left: 80px;
          width: 230px;
          height: 0px;
          padding: 0px;
          background: @font_white;
          border-radius: @border_radius_2;
          box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
          overflow-y: scroll;
          z-index: 9;
          transition: all 0.3s;

          .select_patterns {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: @font_gray;
            font-size: 23px;
            padding: 10px;
            text-align: left;
            border-radius: @border_radius_2;
            cursor: pointer;

            &:hover {
              transition: all 0.5s;
            }
          }
        }

      }

      .selectpatternresult {
        position: relative;
        width: 170px;
        height: 50px;
        color: @font_white;
        background: @morejoy;
        border-radius: @border_radius_2;
        text-align: center;
        cursor: pointer;

        .selectresult {
          padding: 0px 10px;
          font-size: 20px;
          line-height: 50px;
        }

        .selectmodule {
          position: absolute;
          bottom: 60px;
          left: 0px;
          width: 310px;
          height: 0px;
          padding: 0px;
          background: @font_white;
          border-radius: @border_radius_2;
          box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
          overflow-y: scroll;
          z-index: 9;
          transition: all 0.3s;

          .select_items {
            position: relative;
            display: flex;
            padding: 10px;
            flex-direction: column;
            cursor: pointer;
            border-radius: @border_radius_2;
            transition: all 0.3s;

            &:hover {
              transition: all 0.3s;
            }

            span:nth-child(1) {
              display: block;
              height: 25px;
              text-align: left;
              font-size: 20px;
              line-height: 25px;
              color: @font_gray;
              padding: 5px;
            }

            span:nth-child(2) {
              display: block;
              text-align: left;
              font-size: 15px;
              color: @font_gray;
              opacity: 0.8;
              padding: 5px;
            }

            span:nth-child(3) {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 10px;
              display: block;
              text-align: left;
              font-size: 25px;
              color: @font_gray;
              opacity: 0.8;
              padding: 5px;
            }
          }
        }
      }

      .modelTemplate {
        width: 170px;
        height: 50px;
        font-size: 20px;
        color: @font_white;
        background: @morejoy;
        border-radius: @border_radius_2;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          font-size: 22px;
          transition: all 0.5s;
        }
      }

      .resolutionList {
        position: relative;
        width: 170px;
        height: 50px;
        font-size: 20px;
        color: @font_white;
        background: @morejoy;
        border-radius: @border_radius_2;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        transition: all 0.5s;

        span {
          display: block;
          font-size: 20px;
          transition: all 0.5s;

          &:hover {
            font-size: 22px;
            transition: all 0.5s;
          }
        }

        .resolution_item {
          position: absolute;
          bottom: 60px;
          border-radius: @border_radius_2;
          display: flex;
          flex-direction: column;
          width: 170px;
          height: 0px;
          padding: 0px;
          background: @font_white;
          box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
          overflow-y: scroll;
          transition: all 0.5s;

          .res_items {
            display: block;
            color: @font_gray;
            font-size: 20px;
            cursor: pointer;
            border-radius: @border_radius_2;

            &:hover {
              background: @basicselect;
              transition: all 0.5s;
            }
          }
        }
      }

      .resolution {
        position: relative;
        width: 170px;
        height: 50px;
        font-size: 20px;
        color: @font_white;
        background: @morejoy;
        border-radius: @border_radius_2;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        transition: all 0.5s;

        span {
          display: block;
          font-size: 20px;
          transition: all 0.5s;

          &:hover {
            font-size: 22px;
            transition: all 0.5s;
          }
        }

        .resolution_item {
          position: absolute;
          bottom: 60px;
          border-radius: @border_radius_2;
          display: flex;
          flex-direction: column;
          width: 170px;
          height: 0px;
          padding: 0px;
          background: @font_white;
          box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
          overflow-y: scroll;
          transition: all 0.5s;

          .res_items {
            display: block;
            color: @font_gray;
            font-size: 20px;
            cursor: pointer;
            border-radius: @border_radius_2;

            &:hover {
              background: @basicselect;
              transition: all 0.5s;
            }
          }
        }
      }

      .currentSelect {
        padding: 0px 10px;
        min-width: 200px;
        height: 48px;
        text-align: center;
        color: @font_gray;
        border: 2px dashed @font_gray;
        border-radius: @border_radius_2;
        font-size: 20px;
        line-height: 48px;
        opacity: 0.7;
      }

      .sent {
        position: absolute;
        right: 15px;
        bottom: 15px;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 35px;
        color: @font_white;
        border: none;
        border-radius: 30px;
        background-color: @font_gray;
        cursor: pointer;
        opacity: 0.7;
        transition: all 0.3s;

        &:hover {
          opacity: 1;
          font-size: 38px;
        }
      }
    }
  }

}
</style>
